module.exports = __webpack_public_path__ + "img/desktop-8.93766b6c.jpg";